import NextImage from "../../NextImage";
import React from "react";
import { cn } from "utils";

/**
 * EmptyProps - Empty 组件的 props
 */
interface EmptyProps {
  /**
   * 标题
   */
  title?: string;
  /**
   * 描述信息
   */
  description?: string;
  /**
   * 自定义类名
   */
  className?: string;
  /**
   * 自定义描述信息类名
   */
  descriptionClassName?: string;
  /**
   * 图片地址
   */
  src?: string;
  /**
   * 自定义标题类名
   */
  titleClassName?: string;
  /**
   * 是否隐藏标题
   */
  hiddenTitle?: boolean;
  /**
   * 图片大小
   */
  imageSize?: number;
  /**
   * 底部子元素
   */
  bottomChildren?: React.ReactNode;
}

const Empty: React.FC<EmptyProps> = ({
  title,
  description,
  className,
  descriptionClassName,
  titleClassName,
  src,
  hiddenTitle,
  imageSize,
  bottomChildren,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center min-h-[306px] h-full",
        className,
      )}
    >
      <div className={cn("mb-4")}>
        <NextImage
          src={src || "/assets/images/search_no_data.webp"}
          alt="No data"
          width={imageSize || 120}
          height={imageSize || 120}
          className="object-contain"
        />
      </div>
      {!hiddenTitle && (
        <h3
          aria-label="Empty h3"
          data-openreplay-label="chatbox_empty_h3"
          id="sem-empty-h3"
          className={cn(
            "body_medium_l text-content_secondary mb-1",
            titleClassName,
          )}
        >
          {title || "Quiet AF Here, Ser"}
        </h3>
      )}
      <p className={cn("body_m text-content_quaternary", descriptionClassName)}>
        {description ||
          "No breaking news yet about it. Maybe try ape elsewhere?"}
      </p>
      {bottomChildren}
    </div>
  );
};

export default Empty;
